import styled from '@emotion/styled'
import { Button } from 'antd'

export { DeleteButton } from '../styles'

export const OutlineButton = styled(Button)`
  background: #ffffff;
  color: #4a4a68;
  border: 1px solid #4a4a68;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus,
  &:active {
    background: #ffffff;
    color: #4a4a68;
    border: 1px solid #4a4a68;
  }
`

export const PrimaryButton = styled(Button)`
  background-color: #4a4a68;
  color: #ffffff;
  border-color: #4a4a68;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus,
  &:active {
    background-color: #4a4a68;
    color: #ffffff;
    border-color: #4a4a68;
  }

  &:disabled {
    opacity: 0.4;

    &:hover,
    &:focus,
    &:active {
      background-color: #4a4a68;
      color: #ffffff;
      border-color: #4a4a68;
    }
  }
`

export const SidePanel = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  height: fit-content;
  max-width: 360px;
`

export const SidePanelTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #4a4a68;
  margin-bottom: 8px;
`

export const SidePanelList = styled.ol`
  margin: 0;
  padding-left: 20px;
`

export const SidePanelItem = styled.li`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  line-height: 1.6;
`

export const StepGrid = styled.div<{ hasSidebar?: boolean }>(
  ({ hasSidebar }) => `
  display: grid;
  grid-template-columns: ${
    hasSidebar ? 'minmax(580px, 1fr) minmax(320px, 1fr)' : 'minmax(580px, 1fr)'
  };
  gap: 24px;
  align-items: start;
  max-width: ${hasSidebar ? '920px' : '658px'};
  margin: 0 auto;
`
)

export const ContentPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ActionCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  > button {
    width: min-content;
  }
`

export const StepRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #4a4a68;
`

export const OpenShipdayButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #4a4a68;
  border-radius: 4px;
  color: #4a4a68;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  &:hover,
  &:focus {
    color: #4a4a68;
    border-color: #4a4a68;
    text-decoration: none;
  }
`
